
// src/pages/shippment/tabs/ShipmentDetailsTab.jsx
import React from "react";
import { shipmentHeaderFields } from "../formFields/shippmentTabsFields";
import GenericFormTab from "./GenericFormTab";

export default function ShipmentDetailsTab({ formData, onChange, errors = {}, viewOnly = false, isEdit = true }) {
    // forward onChange (do not use handleChange which doesn't exist here)
    return <GenericFormTab fields={shipmentHeaderFields} formData={formData} onChange={onChange} errors={errors} readOnly={viewOnly} isEdit={isEdit} />;
}

